import { IUserProfile } from "modules/app/types";

type FormInputType = {
  name: keyof IUserProfile;
  label: string;
  id?: string;
  required?: boolean;
  maxLength?: number;
  isUrl?: boolean;
};

export const defaultFormInputs: FormInputType[] = [
  {
    name: "firstName",
    label: "first.name",
    id: "outlined-first-name",
    required: true,
    maxLength: 50,
  },
  {
    name: "lastName",
    label: "last.name",
    id: "outlined-last-name",
    required: true,
    maxLength: 50,
  },
  {
    name: "headline",
    label: "onboarding:what.do.you.do",
  },
  {
    name: "company",
    label: "company",
  },
];

export const additionalFormInputs: FormInputType[] = [
  {
    name: "title",
    label: "job.title",
  },
  {
    name: "meetingLink",
    label: "onboarding:meeting.schedule.link",
    isUrl: true,
  },
  {
    name: "linkedInProfileURL",
    label: "onboarding:linked.public.profile.url",
    isUrl: true,
  },
  {
    name: "facebookProfileURL",
    label: "onboarding:facebook.profile.url",
    isUrl: true,
  },
  {
    name: "sansanProfileURL",
    label: "onboarding:sans.public.url",
    isUrl: true,
  },
  {
    name: "website",
    label: "website",
    isUrl: true,
  },
];
